import React, { createContext, FC, useContext, useMemo } from 'react';
import { isMediaFromWix } from '../../media-manager-sdk/sources';
import { extractExplorableMediaCategoryIdAndOrientation } from '../../bi';
import { MainSource } from '../../../constants/Source';

const FileTypeContext = createContext<string>('');

interface IOuter {
  source: MainSource;
  folderId: string;
  getPublicMediaSubcategoryNameAndRoot: (subcategoryId: string) => [string, string];
}

export const FileTypeProvider: FC<IOuter> = ({
  source,
  folderId,
  getPublicMediaSubcategoryNameAndRoot = (_categoryId) => [null, null],
  children,
}) => {
  const fileType = useMemo(() => {
    const [categoryId] = extractExplorableMediaCategoryIdAndOrientation(source, folderId);
    const [, fileType] = isMediaFromWix(source) ? getPublicMediaSubcategoryNameAndRoot(categoryId) : [null, null];
    return fileType || '';
  }, [source, folderId, getPublicMediaSubcategoryNameAndRoot]);

  return <FileTypeContext.Provider value={fileType}>{children}</FileTypeContext.Provider>;
};

export const useFileType = () => useContext(FileTypeContext);

export const FileTypeConsumer = FileTypeContext.Consumer;
